import { render, staticRenderFns } from "./driverFractionDetailsList.vue?vue&type=template&id=3a350f35&scoped=true&"
import script from "./driverFractionDetailsList.vue?vue&type=script&lang=js&"
export * from "./driverFractionDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./driverFractionDetailsList.vue?vue&type=style&index=0&id=3a350f35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a350f35",
  null
  
)

export default component.exports